module.exports = __webpack_public_path__ + "static/3A841E_1_0-2643f317fcd0a35f975b371b1dccd3f7.ttf";